import React from "react";
import { useTranslation } from "react-i18next";
import { BlockStack, InlineStack, Link } from "@shopify/polaris";
import PdfModalViewer from "components/pdf-view/Pdf_modal";

interface AssetActModalProps {
  fileId: string;
  companyId: string;
  categoryId?: string | null;
}

/**
 * Acceptance-transfer act opened from an asset's history.
 *
 * The act is read far more often than it is edited, so it previews right here
 * instead of navigating away — with a link to the same document in the
 * documents module for everything else (categories, signatures, history).
 * The link falls back to the category-less document route: an act whose
 * template has no category still has to be reachable.
 */
const AssetActModal: React.FC<AssetActModalProps> = ({
  fileId,
  companyId,
  categoryId,
}) => {
  const { t } = useTranslation();

  const documentUrl = categoryId
    ? `/app/${companyId}/documents/${categoryId}/${fileId}`
    : `/app/${companyId}/documents/view/${fileId}`;

  return (
    <BlockStack gap="300">
      <InlineStack align="end">
        <Link url={documentUrl}>
          {t("open_in_documents")}
        </Link>
      </InlineStack>
      <PdfModalViewer id={fileId} companyId={companyId} />
    </BlockStack>
  );
};

export default AssetActModal;
